/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* -----------------*/
/* Custom Mega Menu */
/* -----------------*/
/* Get Announcement Bar once, so we don't have to query the DOM every time */
var announcementBar = document.querySelector('.AnnouncementBar') || null;
var announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

/* Calculate visibility of the Announcement bar, relative to scrolling */
/* We use this to calculate the position of the Custom Mega Menu's fixed top position */
function calculateAnnouncementBarPosition() {
  if (!announcementBar || window.scrollY > 100) { /* Optimization: Don't calculate if the user has scrolled down more than 100px */
    return;
  }

  const announcementBarPosition = (announcementBar.getBoundingClientRect().y * -1);
  const calculated = announcementBarPosition > announcementBarHeight ? announcementBarHeight : Math.min(announcementBarPosition, announcementBarHeight);

  document.documentElement.style.setProperty('--announcement-bar-relative-position', calculated + 'px')
}

/* Call the calculation above on page load. No need for DOMContentLoaded, as custom.js is deferred */
calculateAnnouncementBarPosition();

/* Add scroll event listener to the window for the calculation above */
window.addEventListener('scroll', function() {
  calculateAnnouncementBarPosition();
});

/* Custom Mega Menu component - handle onhover navigation change */
var CustomMegaMenu = class CustomMegaMenu extends HTMLElement {
  constructor() {
    super();

    this.navItems = this.querySelectorAll('.CustomMegaMenu__TopLevel .CustomMegaMenu__Link');

    for (const navItem of this.navItems) {
      navItem.addEventListener('mouseover', this.changeActiveSubNav.bind(this))
    }
  }

  changeActiveSubNav(event) {
    const targetAttr = event.target.dataset.openerFor;
    const newTarget = this.querySelector(`[data-linked-to="${ targetAttr }"]`);
    const previousExpanded = this.querySelector('.CustomMegaMenu__Link[aria-expanded="true"]');
    const previousActiveElement = this.querySelector('.CustomMegaMenu__SubNavigation[aria-hidden="false"]');

    event.target.setAttribute('aria-expanded', 'true');

    if (previousExpanded) {
      previousExpanded.setAttribute('aria-expanded', 'false');
    }

    if (previousActiveElement) {
      previousActiveElement.setAttribute('aria-hidden', 'true');
    }

    if (newTarget) {
      newTarget.setAttribute('aria-hidden', 'false');
    }
  }
}

window.customElements.define('custom-mega-menu', CustomMegaMenu);

/* ----------------*/
/* Add to Cart CTA */
/* ----------------*/
var AddToCart = class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.variantId = this.form.querySelector('[name="id"]').value;
    this.quantity = this.form.querySelector('[name="quantity"]').value;

    this.form.addEventListener('submit', this.addToCart.bind(this));
  }

  addToCart(event) {
    event.preventDefault();

    fetch(window.routes.cartAddUrl, {
      method: 'POST',
      body: JSON.stringify({
        id: this.variantId,
        quantity: this.quantity
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: this.variantId,
            quantity: this.quantity
          }
        }));
      }
    }.bind(this));
  }
}

window.customElements.define('add-to-cart', AddToCart);

/* ----------------*/
/* Custom Dropdown */
/* ----------------*/
var CustomDrowpdown = class CustomDrowpdown extends HTMLElement {
  constructor() {
    super();

    /* Attributes */
    this.functionality = this.getAttribute('data-functionality');
    this.optionIndex = this.getAttribute('data-option-index') || null;
    this.shapeType = this.getAttribute('data-for') || null;

    /* Elements */
    this.opener = this.querySelector('.Dropdown__Opener');
    this.content = this.querySelector('.Dropdown__Content');
    this.selectedValueContainer = this.querySelector('.Dropdown__SelectedValue') || null;
    this.customSizes = document.querySelector('custom-width-height');

    /* Variant data */
    this.variantData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
    this.previousVariant = this.variantData.product.variants.find(function (variant) {
      return variant.id === this.variantData.selected_variant_id;
    }.bind(this));

    /* Common Event listeners */
    this.opener.addEventListener('click', this.toggleDropdown.bind(this));
    this.addEventListener('blur', this.closeDropdown.bind(this));
    this.addEventListener('variant:changed', function(event) {
      this.previousVariant = event.detail.variant.id; 
    }.bind(this));

    /* Functionality specific event listeners */
    if (this.functionality === 'product_option' && this.optionIndex !== null) {
      this.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', this.changeProductOption.bind(this));
      }.bind(this));
    }

    if (this.functionality === 'quantity') {
      this.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', this.changeProductQuantity.bind(this));
      }.bind(this));

      document.addEventListener('shape:changed', function(event) {
        const shape = event.detail.shape;

        /* Banderingskleuren verbergen bij iedere vormwissel */
        document.querySelectorAll('.ProductForm__ColorSwatchesWrapper').forEach(function(wrapper) {
          wrapper.setAttribute('aria-hidden', 'true');

          wrapper.querySelectorAll('input[type="radio"]').forEach(function(input) {
            input.checked = false;
          });

          const selectedColorText = wrapper.querySelector('[data-selected-band-color]');

          if (selectedColorText) {
            selectedColorText.textContent = '';
          }
        });

        /* we hide and disable the other quantity inputs */
        if (shape !== this.shapeType) {
          this.setAttribute('hidden', '');
          this.querySelector('[name="quantity"]').setAttribute('disabled', '');
          return;
        }

        /*console.log('Shape changed to: ' + shape);
        console.log(this);*/

        if (shape === 'Vrije vorm') {
          /* If we are on custom shape, we load the custom contact form and hide everything else */
          /* We don't want to re-enable quantity input here, because we will not be adding anything to the cart anyways */
          const toHideElements = this.closest('.Product__Info').querySelectorAll('.ProductForm > *:not(.ProductMeta, .ProductForm__ShapeSelectorWrapper, .CustomShapeForm)');
          const toShowElement = this.closest('.Product__Info').querySelector('.CustomShapeForm');

          for (const elem of toHideElements) {
            elem.setAttribute('hidden', '');
          }

          if (toShowElement) {
            toShowElement.removeAttribute('hidden');
          }
        } else {
          /* otherwise we show and enable the current quantity input */
          /* Eerst ALLES uitzetten */
          document.querySelectorAll('custom-dropdown[data-functionality="quantity"]').forEach(function(dropdown) {
            dropdown.querySelector('[name="quantity"]').setAttribute('disabled', '');
          });

          /* Dan alleen deze activeren */
          this.removeAttribute('hidden');
          this.querySelector('[name="quantity"]').removeAttribute('disabled');
        
          /* Zorg dat alle andere quantity inputs disabled zijn */
          document.querySelectorAll('custom-dropdown[data-functionality="quantity"]').forEach(function(dropdown) {
            if (dropdown !== this) {
              dropdown.querySelector('[name="quantity"]').setAttribute('disabled', '');
            }
          }.bind(this));

          /* Reset de zichtbare maatkeuze bij vormwissel */
          this.classList.remove('nw-has-selection');

          this.querySelectorAll('input[type="radio"]').forEach(function(radio) {
            if (!radio.disabled) {
              radio.checked = false;
            }
          });

          if (this.selectedValueContainer) {
            this.selectedValueContainer.textContent = '';
          }

          const placeholderEl = this.querySelector('.Dropdown__Placeholder');

          if (placeholderEl) {
            placeholderEl.style.opacity = '1';
            placeholderEl.style.visibility = 'visible';
          }

          if (this.customSizes) {
            this.customSizes.querySelectorAll('input').forEach(function(input) {
              input.value = '';
            });
          }

          const quantityInput = this.querySelector('[name="quantity"]');
          const minQty = parseInt(quantityInput.getAttribute('min'), 10) || 0;
          quantityInput.value = minQty;

          /* Kleur bandering resetten bij vormwissel */
          document.querySelectorAll('.ProductForm__ColorSwatchesWrapper input[type="radio"]').forEach(function(radio) {
            radio.checked = false;
          });

          document.dispatchEvent(new CustomEvent('color:changed', {
            bubbles: true,
            detail: {
              color: null
            }
          }));

           /* Kleur bandering resetten bij vormwissel */
          document.querySelectorAll('.ProductForm__ColorSwatchesWrapper input[type="radio"]').forEach(function(radio) {
            radio.checked = false;
          });

          document.dispatchEvent(new CustomEvent('color:changed', {
            bubbles: true,
            detail: {
              color: null
            }
          }));

          /* Prijs direct verversen zodat oude vorm-prijs niet blijft staan */
          /* Randafwerking resetten bij vormwissel */
          const edgeDropdown = document.querySelector(
            'custom-dropdown[data-functionality="product_option"][data-option-index="1"]'
          );

          if (edgeDropdown) {
            edgeDropdown.querySelectorAll('input[type="radio"]').forEach(function(radio) {
              radio.checked = false;
            });

            const emptyOption = edgeDropdown.querySelector('input[type="radio"][value=""]');
            if (emptyOption) {
              emptyOption.checked = true;
            }

            edgeDropdown.classList.remove('nw-has-selection');

            const selectedValue = edgeDropdown.querySelector('.Dropdown__SelectedValue');
            if (selectedValue) {
              selectedValue.textContent = '';
            }
          }
          updatePriceDisplay();
          syncStickyBarQuantity();  
          const productFormChildren = this.closest('.Product__Info').querySelectorAll('.ProductForm > *');
          const toShowElement = this.closest('.Product__Info').querySelector('.CustomShapeForm');

          /* Alles behalve CustomShapeForm weer zichtbaar maken,
            MAAR laat hidden quantity-dropdowns met rust */
          for (const elem of productFormChildren) {
            if (elem.classList?.contains('CustomShapeForm')) {
              continue;
            }

            if (
              elem.matches &&
              elem.matches('custom-dropdown[data-functionality="quantity"]') &&
              elem !== this
            ) {
              continue;
            }

            elem.removeAttribute('hidden');
          }

          if (toShowElement) {
            toShowElement.setAttribute('hidden', '');
          }

          if (toShowElement) {
            toShowElement.setAttribute('hidden', '');
          }
          
        }
      }.bind(this));
    }
  }

  toggleDropdown() {
    this.closeOtherDropdowns();

    if (this.content.getAttribute('aria-hidden') === 'true') {
      this.content.setAttribute('aria-hidden', 'false');

      return;
    }

    this.content.setAttribute('aria-hidden', 'true');
  }

  closeDropdown() {
    this.content.setAttribute('aria-hidden', 'true');
  }

  closeOtherDropdowns() {
    const otherDropdowns = document.querySelectorAll('custom-dropdown');

    for (const dropdown of otherDropdowns) {
      if (dropdown !== this) {
        dropdown.closeDropdown();
      }
    }
  }

  changeProductOption(event) {
    this.closeDropdown();

    /* Set the selected value container's text to the selected option */
    if (this.selectedValueContainer) {
      this.selectedValueContainer.innerHTML = event.target.value;
    }

    /* Show/Hide dependant options */
    const triggerOptionName = event.target.name;
    const dependsOnOptions = document.querySelectorAll(`[data-depends-on="${ triggerOptionName }"]`);

    for (const option of dependsOnOptions) {
      let makeVisible = false;
      const dependingValues = option.dataset.dependingValues.split(',');

      for (const value of dependingValues) {
        if (value === event.target.value) {
          makeVisible = true;
          break;
        }
      }

      if (makeVisible) {
        option.setAttribute('aria-hidden', 'false');
      } else {
        option.setAttribute('aria-hidden', 'true');
        
        const previouslySelectedOption = option.querySelector('input[type="radio"]:checked');

        if (previouslySelectedOption) {
          previouslySelectedOption.checked = false;
        }
      }

      if (option.classList.contains('ProductForm__ColorSwatchesWrapper') && option.getAttribute('aria-hidden') === 'true') {
        const firstInput = option.querySelector('input');

        document.dispatchEvent(new CustomEvent('color:changed', {
          bubbles: true,
          detail: {
            color: null
          }
        }));
      }
    }

    /* Find & Update the variant */
    const option1 = document.querySelector('custom-dropdown [name="option-1"]:checked') || null;
    const option2 = document.querySelector('custom-dropdown [name="option-2"]:checked') || null;
    const option3 = document.querySelector('custom-dropdown [name="option-3"]:checked') || null;

    const selectedOptions = {
      option1: option1 !== null ? (option1.value !== '' ? option1.value : null) : null,
      option2: option2 !== null ? (option2.value !== '' ? option2.value : null) : null,
      option3: option3 !== null ? (option3.value !== '' ? option3.value : null) : null
    }
    
    let selectedVariantName = '';

    for (let i = 0; i < Object.keys(selectedOptions).length; i++) {
      const currentProperty = selectedOptions[`option${ i + 1 }`];
      const nextPropety = selectedOptions[`option${ i + 2 }`];

      if (typeof currentProperty !== 'undefined' && currentProperty !== null) {
        if (typeof nextPropety !== 'undefined' && nextPropety !== null) {
          selectedVariantName += currentProperty + ' / ';
        } else {
          selectedVariantName += currentProperty;
        }
      }
    }

    let selectedVariant = null;

    for (const variant of this.variantData.product.variants) {
      if (variant.title === selectedVariantName) {
        selectedVariant = variant;

        break;
      }
    }

    if (selectedVariant !== null) {
      document.querySelector('[name="id"]').value = selectedVariant.id;

      /* To support the same event as Prestige sends by default */
      this.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: selectedVariant,
          previousVariant: this.previousVariant
        }
      }));
    }
  }

  changeProductQuantity(event) {
    /* First we close the dropdown */
    this.closeDropdown();

    /* Then we update the selected value text if there's a container for it */
    if (this.selectedValueContainer) {
      this.selectedValueContainer.innerHTML = event.target.value;
    }

    /* Then we reset the custom sizes inputs */
    if (this.customSizes) {
      this.customSizes.querySelectorAll('input').forEach(function (input) {
        input.value = '';
      });
    }

    /* Then we set the quantity */
   const quantityInput = this.querySelector('[name="quantity"]');
   const minQty = parseInt(quantityInput.getAttribute('min'), 10) || 0;
   const rawValue = event.target.dataset.value;
   const parsedValue = parseInt(rawValue, 10);

   quantityInput.value =
     rawValue === 'placeholder'
       ? minQty
       : (!isNaN(parsedValue) ? parsedValue : minQty);
    
    /* Update price display and sync sticky bar */
    updatePriceDisplay();
    syncStickyBarQuantity();
  }

  showRelevantSelector() {

  }
}

window.customElements.define('custom-dropdown', CustomDrowpdown);

/* -----------------------*/
/* Custom Width / Height */
/* ----------------------*/
var CustomWidthHeight = class CustomWidthHeight extends HTMLElement {
  constructor() {
    super();

    this.widthInput = this.querySelector('[name="properties[Breedte]"]') || null;
    this.heightInput = this.querySelector('[name="properties[Lengte]"]') || null;
    //this.sizeDropdown = document.querySelector('custom-dropdown[data-functionality="quantity"]') || null;

    if (this.widthInput) {
      this.widthInput.addEventListener('input', function (event) {
        this.changeProductQuantityCustom(event, 'width');
      }.bind(this));
    }

    if (this.heightInput) {
      this.heightInput.addEventListener('input', function (event) {
        this.changeProductQuantityCustom(event, 'height');
      }.bind(this));
    }
  }

  changeProductQuantityCustom(event, axis) {
    /* First we update the input value */
    if (axis === 'width') {
      this.widthInput.value = event.target.value;
    } else {
      this.heightInput.value = event.target.value;
    }

    const sizeDropdown = document.querySelector('custom-dropdown[data-functionality="quantity"]:not([hidden])') || null;
    let shapeType = null;

    if (sizeDropdown) {
      shapeType = sizeDropdown.getAttribute('data-for');
    }

    /* Then we reset the standard size value */
    if (sizeDropdown) {
      sizeDropdown.querySelector('[data-placeholder]').checked = true;

      const selectedValueContainer = sizeDropdown.querySelector('.Dropdown__SelectedValue');

      if (selectedValueContainer) {
        selectedValueContainer.innerHTML = '';
      }
    }

    /* Then we calculate the new quantity */
    const currentWidth = this.widthInput.value;
    const currentHeight = this.heightInput.value;
  
    /* If we are on circle, we make the two inputs identical */
    if (shapeType === 'Rond') {
      const biggerSide = currentHeight > currentWidth ? currentHeight : currentWidth;

      this.widthInput.value = biggerSide;
      this.heightInput.value = biggerSide;
    }

    const activeQuantityInput = getActiveQuantityInput();
    const minQty = activeQuantityInput ? activeQuantityInput.getAttribute('min') : 0;
    let roundedQty = null;

    switch (shapeType) {
      case 'Recht':
        roundedQty = Math.round((currentWidth * currentHeight) / 100);
        break;
      case 'Rond':
        const radius = this.widthInput.value / 2; /* doesn't matter whether we choose width or height, because by this time they are identical */
        roundedQty = Math.round((Math.PI * Math.pow(radius, 2)) / 100);
        break;
      case 'Vrije vorm':
        roundedQty = Math.round((currentWidth * currentHeight) / 100); /* Placeholder for now, until we have a formula to work with */
        break;
      default:
        roundedQty = minQty;
        break;
    }

    const calculatedQty = (isNaN(roundedQty) === false ? roundedQty : minQty);

    if (activeQuantityInput) {
      activeQuantityInput.value = calculatedQty < minQty ? minQty : calculatedQty;
    }
    
    /* Update price display and sync sticky bar */
    updatePriceDisplay();
    syncStickyBarQuantity();
  }
}

window.customElements.define('custom-width-height', CustomWidthHeight);

function getActiveQuantityInput() {
  const selectedShapeInput = document.querySelector('.ProductForm__ShapeSelector input:checked');
  const selectedShape = selectedShapeInput ? selectedShapeInput.value : null;

  if (!selectedShape) {
    return null;
  }

  const activeDropdown = document.querySelector(
    `custom-dropdown[data-functionality="quantity"][data-for="${selectedShape}"]`
  );

  return activeDropdown ? activeDropdown.querySelector('[name="quantity"]') : null;
}

/* ---------------*/
/* Price Display  */
/* ---------------*/
function syncStickyBarQuantity() {
  const mainQuantityInput = getActiveQuantityInput();
  const stickyQuantityInput = document.querySelector('#ProductStickyBar__Quantity');
  
  if (mainQuantityInput && stickyQuantityInput) {
    stickyQuantityInput.value = mainQuantityInput.value;
  }
}

function updateEdgeFinishPrices() {
  const productDataElement = document.querySelector('[data-product-json]');
  const quantityInput = getActiveQuantityInput();
  const priceElements = document.querySelectorAll('[data-edge-price]');

  if (!productDataElement || !priceElements.length) return;

  const productData = JSON.parse(productDataElement.textContent);
  const variants = productData.product.variants;

  const getVariantPrice = function(finish) {
    const variant = variants.find(function(item) {
      return item.option1 === finish;
    });

    return variant ? variant.price : null;
  };

  const festonPrice = getVariantPrice('Feston');
  if (festonPrice === null) return;

  const activeDropdown = quantityInput
  ? quantityInput.closest('custom-dropdown')
  : null;

const hasSelectedSize = activeDropdown && (
  !!activeDropdown.querySelector('input[type="radio"]:checked:not([data-placeholder])') ||
  (
    document.querySelector('custom-width-height [name="properties[Breedte]"]')?.value &&
    document.querySelector('custom-width-height [name="properties[Lengte]"]')?.value
  )
);

const quantity = hasSelectedSize
  ? parseInt(quantityInput.value, 10) || 0
  : 0;

  priceElements.forEach(function(element) {
    const finish = element.getAttribute('data-edge-price');

    if (quantity <= 0) {
  element.textContent = '';
  return;
}

if (finish === 'Feston') {
  element.textContent = 'Inbegrepen';
  return;
}

    const finishPrice = getVariantPrice(finish);

    if (finishPrice === null || quantity <= 0) {
      element.textContent = '';
      return;
    }

    const difference = (finishPrice - festonPrice) * quantity;

    element.textContent = difference > 0
      ? '+ ' + new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: 'EUR'
        }).format(difference / 100)
      : 'Inbegrepen';
  });
}

function updatePriceDisplay() {
  const priceDisplays = document.querySelectorAll('[data-base-price]');
  const quantityInput = getActiveQuantityInput();
  
  if (!priceDisplays.length || !quantityInput) {
    return;
  }
  
  const quantity = parseInt(quantityInput.value, 10) || 0;
  
  priceDisplays.forEach(function(priceDisplay) {
    const priceDisplayValue = priceDisplay.querySelector('[data-price-display]');
    if (!priceDisplayValue) {
      return;
    }
    
    const basePrice = parseInt(priceDisplay.getAttribute('data-base-price'), 10);
    
    if (basePrice && quantity > 0) {
      const totalPrice = basePrice * quantity;
      const priceInEuros = (totalPrice / 100).toFixed(2);
      const formattedPrice = priceInEuros.replace('.', ',');
      priceDisplayValue.textContent = '€' + formattedPrice;
    }
  });
   updateEdgeFinishPrices();
   /* Sticky banner: vanafprijs of berekende totaalprijs */
    const stickyPrice = document.querySelector('.ProductStickyBar__Price');

    if (stickyPrice) {
      const label = stickyPrice.querySelector('[data-sticky-price-label]');
      const unit = stickyPrice.querySelector('[data-sticky-price-unit]');
      const value = stickyPrice.querySelector('[data-price-display]');

      const activeDropdown = quantityInput.closest('custom-dropdown');

      const standardSizeSelected = !!activeDropdown?.querySelector(
        'input[type="radio"]:checked:not([data-placeholder])'
      );

      const width = document.querySelector(
        'custom-width-height [name="properties[Breedte]"]'
      )?.value;

      const height = document.querySelector(
        'custom-width-height [name="properties[Lengte]"]'
      )?.value;

      const hasSelectedSize = standardSizeSelected || (!!width && !!height);

      if (label && unit && value) {
        if (hasSelectedSize) {
          label.textContent = 'Jouw prijs:';
          unit.hidden = true;
        } else {
          label.textContent = 'Vanaf';
          unit.hidden = false;

          const productDataElement = document.querySelector('[data-product-json]');
          const productData = productDataElement
            ? JSON.parse(productDataElement.textContent)
            : null;

          const festonVariant = productData?.product?.variants?.find(function(variant) {
            return variant.option1 === 'Feston';
          });

          if (festonVariant) {
            value.textContent = new Intl.NumberFormat('nl-NL', {
              style: 'currency',
              currency: 'EUR'
            }).format(festonVariant.price);
          }
        }
      }
    }
}

window.addEventListener('DOMContentLoaded', function() {
  const shapeInputs = document.querySelectorAll('.ProductForm__ShapeSelector input');
  const customColorInputs = document.querySelectorAll('.ProductForm__ColorSwatchesWrapper input');

  for (const input of shapeInputs) {
    input.addEventListener('change', function(event) {
      if (!event.target.checked) {
        return;
      }

      document.dispatchEvent(new CustomEvent('shape:changed', {
        bubbles: true,
        detail: {
          shape: event.target.value
        }
      }));
    });
  }

  for (const input of customColorInputs) {
    input.addEventListener('change', function(event) {
      if (!event.target.checked) {
        return;
      }

      console.log('sending color change event');
      document.dispatchEvent(new CustomEvent('color:changed', {
        bubbles: true,
        detail: {
          color: event.target.value.replaceAll(' ', '_').toLowerCase()
        }
      }));
    });
  }

  // init
  const checkedShapeInput = document.querySelector('.ProductForm__ShapeSelector input:checked');
  const checkedColorInput = document.querySelector('.ProductForm__ColorSwatchesWrapper input:checked');

  if (checkedShapeInput) {
    document.dispatchEvent(new CustomEvent('shape:changed', {
      bubbles: true,
      detail: {
        shape: checkedShapeInput.value
      }
    }));
  }

  if (checkedColorInput) {
    document.dispatchEvent(new CustomEvent('color:changed', {
      bubbles: true,
      detail: {
        color: checkedColorInput.value.value.replaceAll(' ', '_').toLowerCase()
      }
    }));
  }

  document.addEventListener('color:changed', function(event) {
    const color = event.detail.color;

    if (color === null) {
      const allSlides = document.querySelectorAll('.Product__SlideItem');

      for (let i = 0; i < allSlides.length; i++) {
        const slide = allSlides[i];

        if (i === 0) {
          slide.classList.add('is-selected');
          slide.removeAttribute('hidden');

          continue;
        }

        slide.classList.remove('is-selected');
        slide.setAttribute('hidden', '');
      }

      const flickityNav = document.querySelector('.Product__SlideshowMobileNav');

      flickityNav?.setAttribute('hidden', '');

      const slideshow = Flickity?.data('.Product__Slideshow');

      if (slideshow) {
        slideshow.element.style.pointerEvents = 'all';

        slideshow.reloadCells();
        slideshow.resize();
        slideshow.selectCell(0);
      }

      return;
    }

    const currentlyActiveImage = document.querySelector('.Product__SlideItem.is-selected');
    const nonCustomImages = document.querySelectorAll('.Product__SlideItem:not([id^="Media-custom-swatch"])');
    const targetImage = document.querySelector(`.Product__SlideItem[id$="${ color }"]`);
    const flickityIndex = Number(targetImage.getAttribute('data-image-media-position'));
    const flickityNav = document.querySelector('.Product__SlideshowMobileNav');

    if (!currentlyActiveImage || !targetImage || currentlyActiveImage === targetImage) {
      return;
    }

    currentlyActiveImage.classList.remove('is-selected');
    currentlyActiveImage.setAttribute('hidden', '');

    targetImage.classList.add('is-selected');
    targetImage.removeAttribute('hidden');

    for (const image of nonCustomImages) {
      image.setAttribute('hidden', '');
    }

    flickityNav?.setAttribute('hidden', '');

    const slideshow = Flickity?.data('.Product__Slideshow');

    if (slideshow) {
      slideshow.element.style.pointerEvents = 'none';

      slideshow.reloadCells();
      slideshow.resize();
      slideshow.selectCell(flickityIndex);
    }
  });
  
  // Price display updates - sync quantity and price
  document.addEventListener('input', function(event) {
    if (event.target.matches('custom-dropdown[data-functionality="quantity"]:not([hidden]) [name="quantity"]')) {
      updatePriceDisplay();
      syncStickyBarQuantity();
    }
  });

  document.addEventListener('change', function(event) {
    if (event.target.matches('custom-dropdown[data-functionality="quantity"]:not([hidden]) [name="quantity"]')) {
      updatePriceDisplay();
      syncStickyBarQuantity();
    }
  });
  
  document.addEventListener('variant:changed', function(event) {
    const priceDisplays = document.querySelectorAll('[data-base-price]');
    const variantIdInputs = document.querySelectorAll('[name="id"]');
    
    if (event.detail.variant?.price) {
      priceDisplays.forEach(function(priceDisplay) {
        priceDisplay.setAttribute('data-base-price', event.detail.variant.price);
      });
      
      variantIdInputs.forEach(function(input) {
        input.value = event.detail.variant.id;
      });
      
      updatePriceDisplay();
    }
  });
  
  updatePriceDisplay(); // Initial load
  syncStickyBarQuantity(); // Initial sync
});



document.addEventListener("submit", function (e) {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches('form[action^="/cart/add"]')) return;

  // Zoek binnen het productform naar de custom quantity selector
  // (werkt voor veel custom blocks: input/select met 'placeholder' of lege waarde)
  const placeholderEl =
    form.querySelector('[data-placeholder="true"]') ||
    form.querySelector('select option[value="placeholder"]:checked') ||
    form.querySelector('select option:checked') ||
    null;

  // Specifiek: check op value "placeholder" of tekst "Kies afmeting"/"Standaardafmeting"
  let isPlaceholderSelected = false;

  // Case: select
  const select = form.querySelector('select[name*="properties"], select[name*="quantity"], select');
  if (select) {
    const val = (select.value || "").toLowerCase();
    const txt = (select.options[select.selectedIndex]?.textContent || "").trim().toLowerCase();
    if (val === "placeholder" || val === "" || txt === "standaardafmeting" || txt === "kies afmeting") {
      isPlaceholderSelected = true;
    }
  }

  // Case: custom input (sommige selectors schrijven "placeholder" in een hidden input)
  const hidden = form.querySelector('input[type="hidden"][value="placeholder"], input[type="hidden"][value="Standaardafmeting"]');
  if (hidden) isPlaceholderSelected = true;

  if (isPlaceholderSelected) {
    e.preventDefault();
    e.stopPropagation();

    // nette inline foutmelding (minimaal)
    let err = form.querySelector(".nw-size-error");
    if (!err) {
      err = document.createElement("div");
      err.className = "nw-size-error";
      err.setAttribute("role", "alert");
      err.textContent = "Selecteer een afmeting om verder te gaan.";
      form.prepend(err);
    }

    err.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}, true);

  /* ==============================
    CUSTOM CART DRAWER - Natweave
    ============================== */

  (function() {
    var cartDrawer = document.getElementById('CartDrawer');
    var cartDrawerItems = document.getElementById('CartDrawerItems');

    if (!cartDrawer || !cartDrawerItems) {
      return;
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : undefined);
      }

      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function openCartDrawer() {
      cartDrawer.classList.add('is-open');
      document.body.classList.add('CartDrawer--open');
    }

    function closeCartDrawer() {
      cartDrawer.classList.remove('is-open');
      document.body.classList.remove('CartDrawer--open');
    }

    function renderCartItems(cart) {
      if (!cart.items || !cart.items.length) {
        cartDrawerItems.innerHTML = '<p>Je winkelmand is leeg.</p>';
        return;
      }

      var html = '';

      cart.items.forEach(function(item) {
        var title = (item.product_title || '').toLowerCase();

        var isSample =
          title.indexOf('sample') > -1 ||
          title.indexOf('staal') > -1 ||
          title.indexOf('monster') > -1;

        var sizeValue = '';
        var edgeValue = '';

        // Randafwerking uit options_with_values halen
        if (item.options_with_values && item.options_with_values.length) {
          item.options_with_values.forEach(function(option) {
            var optionName = (option.name || '').toLowerCase();
            var optionValue = option.value || '';

            if (
              optionName.indexOf('randafwerking') > -1 ||
              optionName.indexOf('afwerking') > -1 ||
              optionName.indexOf('edge') > -1 ||
              optionName.indexOf('border') > -1
            ) {
              edgeValue = optionValue;
            }
          });
        }

        // Afmeting uit variant_title halen
        if (item.variant_title && item.variant_title !== 'Default Title') {
          var parts = item.variant_title.split(' / ');

          parts.forEach(function(part) {
            var cleanPart = part.trim();
            var lowerPart = cleanPart.toLowerCase();

            if (
              lowerPart.indexOf('cm') > -1 ||
              /\d+\s*x\s*\d+/.test(lowerPart)
            ) {
              sizeValue = cleanPart;
            }
          });
        }

        if (!sizeValue && item.variant_title && item.variant_title !== 'Default Title') {
          var parts = item.variant_title.split(' / ');

          parts.forEach(function(part) {
            var cleanPart = part.trim();
            var lowerPart = cleanPart.toLowerCase();

            if (
              !sizeValue &&
              (
                lowerPart.indexOf('cm') > -1 ||
                lowerPart.indexOf('mm') > -1 ||
                /\d+\s*x\s*\d+/.test(lowerPart)
              )
            ) {
              sizeValue = cleanPart;
            }

            if (
              !edgeValue &&
              (
                lowerPart.indexOf('feston') > -1 ||
                lowerPart.indexOf('band') > -1 ||
                lowerPart.indexOf('rand') > -1 ||
                lowerPart.indexOf('afwerking') > -1 ||
                lowerPart.indexOf('border') > -1
              )
            ) {
              edgeValue = cleanPart;
            }
          });
        }

        var metaHtml = '';

        if (isSample) {
          metaHtml = '<p class="CartDrawer__ItemVariant">Aantal: ' + item.quantity + '</p>';
        } else {
          if (sizeValue) {
            metaHtml += '<p class="CartDrawer__ItemVariant">Afmeting: ' + sizeValue + '</p>';
          }

          if (edgeValue) {
            metaHtml += '<p class="CartDrawer__ItemVariant">Randafwerking: ' + edgeValue + '</p>';
          }
        }
              
        html +=
          '<div class="CartDrawer__Item">' +
            '<div class="CartDrawer__ItemImage">' +
              (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '">' : '') +
            '</div>' +
            '<div class="CartDrawer__ItemInfo">' +
              '<p class="CartDrawer__ItemTitle">' + item.product_title + '</p>' +
              metaHtml +
              '<p class="CartDrawer__ItemPrice">' + formatMoney(item.final_line_price || item.line_price || item.price) + '</p>' +
            '</div>' +
          '</div>';
      });

      cartDrawerItems.innerHTML = html;
    }

      function updateCartDrawer(openAfterUpdate) {
        fetch('/cart.js', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function(response) {
            return response.json();
          })
          .then(function(cart) {
            renderCartItems(cart);

            var subtotalElement = document.getElementById('CartDrawerSubtotal');
            if (subtotalElement) {
              subtotalElement.innerHTML = 'Subtotaal: ' + formatMoney(cart.total_price);
            }

            if (openAfterUpdate) {
              openCartDrawer();
            }
          })
          .catch(function(error) {
            console.error('Cart drawer fout:', error);
          });
      }

    document.addEventListener('click', function(event) {
      if (event.target.matches('[data-cart-close]')) {
        closeCartDrawer();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeCartDrawer();
      }
    });

    window.NatweaveCartDrawer = {
      open: openCartDrawer,
      close: closeCartDrawer,
      refresh: function() {
        updateCartDrawer(false);
      },
      refreshAndOpen: function() {
        updateCartDrawer(true);
      }
    };
  })();

  /* ==============================
   OPEN CART DRAWER NA ADD TO CART
   ============================== */

document.addEventListener('submit', function(event) {
  var form = event.target;

  if (!form.matches('form[action*="/cart/add"]')) {
    return;
  }

  event.preventDefault();

  var formData = new FormData(form);

  if (form.querySelector('[data-natweave-rug="true"]')) {
  var quantityInput = form.querySelector(
    'custom-dropdown[data-functionality="quantity"]:not([hidden]) input[name="quantity"]:not([disabled])'
  );

  if (quantityInput) {
    formData.set('properties[_natweave_quantity_per_rug]', quantityInput.value);
  }
}

  for (var pair of formData.entries()) {
  console.log(pair[0] + ': ' + pair[1]);
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    },
    body: formData
  })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Toevoegen aan winkelmand mislukt.');
      }

      return response.json();
    })
    .then(function() {
      var rugButton = form.querySelector('[data-natweave-rug="true"]');

      if (rugButton) {
        window.location.assign('/cart');
        return;
      }

      if (window.NatweaveCartDrawer) {
        window.NatweaveCartDrawer.refreshAndOpen();
      }
    })
    .catch(function(error) {
      console.error('Add to cart fout:', error);
    });
});

/* ==============================
   RANDAFWERKING INFO TOGGLE
   ============================== */
   
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-rand-info-toggle]');
  if (!button) return;

  const dropdown = button.closest('custom-dropdown');
  const info = dropdown ? dropdown.querySelector('[data-rand-info]') : null;

  if (info) {
    info.hidden = !info.hidden;
  }
});